// src/views/components/ViewResultsTab.js
import React, { useMemo, useState } from "react";
import { Select, SIZE as SSIZE } from "baseui/select";
import { Button, SHAPE, SIZE as BSIZE } from "baseui/button";
import { Block } from "baseui/block";
import { FlexGrid, FlexGridItem } from "baseui/flex-grid";
import { styled } from "baseui";
import { connect } from "react-redux";
import VtkViewerComponent from "../../components/vtk-viewer/VtkViewerComponent";
import useFileFetcher from "../../hooks/useFileFetcher";

const VIEW_EXT = "vtksz";
const Wrapper = styled(Block, { border: "1px dashed #AAA", borderRadius: "8px" });

function ModelerPostPorcessingViewResultsy({ activeModeler, assets = [] }) {
  const viewAssets = useMemo(
    () => assets.filter((a) => a.filename.toLowerCase().endsWith(`.${VIEW_EXT}`)),
    [assets]
  );

  const viewOptions = viewAssets.map((a) => ({
    id: a.filename,
    label: a.filename,
    asset: a,
  }));

  const [viewSel, setViewSel] = useState([]);
  const [fileData, setFileData] = useState(null);
  const { fetchFile, loading, error } = useFileFetcher();
  const [viewErr, setViewErr] = useState("");

  const handleLoad = async () => {
    setViewErr("");
    const asset = viewSel[0]?.asset;
    if (!asset) return setViewErr("Choose a .vtksz file first");
    if (!activeModeler?.id) return setViewErr("No active modeler selected");

    try {
      const s3Key = `${activeModeler.id}/${asset.name}`;
      const data = await fetchFile("modeler", s3Key, asset.filename);
      setFileData(data);
    } catch (err) {
      console.error(err);
      setViewErr("Failed to load the file. Please try again.");
    }
  };

  return (
    <Wrapper width="100%" padding="scale600">
      <FlexGrid flexGridColumnCount={2} flexGridColumnGap="scale600" alignItems="center">
        <FlexGridItem>
          <Select
            size={SSIZE.compact}
            options={viewOptions}
            value={viewSel}
            placeholder="Choose a .vtksz result file"
            onChange={({ value }) => setViewSel(value)}
            clearable={false}
            overrides={{ ControlContainer: { style: { width: "100%" } } }}
            error={!!viewErr}
          />
        </FlexGridItem>
        <FlexGridItem display="flex" justifyContent="flex-end">
          <Button
            onClick={handleLoad}
            shape={SHAPE.pill}
            size={BSIZE.compact}
            disabled={viewOptions.length === 0 || loading}
            isLoading={loading}
          >
            Load
          </Button>
        </FlexGridItem>
      </FlexGrid>

      {(error || viewErr) && (
        <Block marginTop="scale400" color="negative500">
          {error}
        </Block>
      )}

      <Block height="600px" display="flex" alignItems="center" justifyContent="center">
        {fileData && <VtkViewerComponent fileData={fileData} />}
      </Block>
    </Wrapper>
  );
}

const mapStateToProps = (state) => ({
  activeModeler: state.modeler.activeModeler,
  assets: state.modelRun?.selectedModelRun?.assets || [],
});

export default connect(mapStateToProps)(ModelerPostPorcessingViewResultsy);